/* class - tracker wrapper + track methods inside */
export { NewsMediaPulseTracker } from './NewsMediaPulseTracker.js';
//# sourceMappingURL=index.js.map